import 'slick-carousel';
import debounce from './debounce';

$(() => {
	const $servicesSlider = $('.mobil-slider.services');

	if (!$servicesSlider.length) {
		return;
	}

	const servicesSliderOptions = {
		dots: true,
		arrows: false,
		infinite: true,
		autoplay: true,
		adaptiveHeight: true,
		responsive: [
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				}
			}
		]
	};

	if (window.matchMedia('(max-width: 991px)').matches) {
		$servicesSlider.slick(servicesSliderOptions);
	}

	$(window).resize(debounce(() => {
		if (window.matchMedia('(max-width: 991px)').matches) {
			if (!$servicesSlider.hasClass('slick-initialized')) {
				$servicesSlider.slick(servicesSliderOptions);
			}
		} else {
			if ($servicesSlider.hasClass('slick-initialized')) {
				$servicesSlider.slick("unslick");
			}
		}
	}, 200));
});



// WEBPACK FOOTER //
// ./assets/scripts/slider-services.js